/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb5_Workflow_4Inputs */

const en_visa_eb5_workflow_4 = /** @type {(inputs: Visa_Eb5_Workflow_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File the next-stage petition or application when the case is eligible to move forward.`)
};

const pt_visa_eb5_workflow_4 = /** @type {(inputs: Visa_Eb5_Workflow_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apresentar a petição ou solicitação da próxima etapa quando o caso estiver elegível para avançar.`)
};

const es_visa_eb5_workflow_4 = /** @type {(inputs: Visa_Eb5_Workflow_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Presentar la petición o solicitud de la siguiente etapa cuando el caso sea elegible para avanzar.`)
};

/**
* | output |
* | --- |
* | "File the next-stage petition or application when the case is eligible to move forward." |
*
* @param {Visa_Eb5_Workflow_4Inputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb5_workflow_4 = /** @type {((inputs?: Visa_Eb5_Workflow_4Inputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb5_Workflow_4Inputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb5_workflow_4(inputs)
	if (locale === "es") return es_visa_eb5_workflow_4(inputs)
	return en_visa_eb5_workflow_4(inputs)
});